import { useEffect } from "react"
import { toast } from "react-toastify"
import useUserEligibility from "~hooks/useUserEligibility"
import EligibilityList from "~components/eligibility/EligibilityList"

interface Props {
  userId: string
}

const Eligibility = ({ userId }: Props) => {
  const {
    data: eligibility,
    refetch: fetchEligibility,
    fetchNextPage,
    isFetching,
    isFetchingNextPage,
    isError: errorFetchingEligibility,
  } = useUserEligibility(userId)

  useEffect(() => {
    if (errorFetchingEligibility) {
      toast.error(`Failed to load user eligibility`)
    }
  }, [errorFetchingEligibility])

  useEffect(() => {
    if (!userId) return
    ;(async () => {
      await fetchEligibility()
    })()
  }, [userId])

  return (
    <EligibilityList
      eligibilities={
        eligibility?.pages.flatMap((page: any) => page.result) ?? []
      }
      isLoading={isFetching}
      fetchNextPage={fetchNextPage}
      hasNextPage={
        eligibility?.pages[eligibility.pages.length - 1]?.hasNextPage
      }
      isFetchingNextPage={isFetchingNextPage}
    />
  )
}

export default Eligibility
